var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_2377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41162 17.0376C5.07501 17.8853 5.67878 18.7783 6.21856 19.71C6.67943 20.5863 6.87156 21.1804 7.20837 22.2362C7.41493 22.8196 7.60162 22.9937 8.003 22.9937C8.44037 22.9937 8.63881 22.6975 8.79212 22.2394C9.1105 21.2424 9.36031 20.4814 9.75443 19.7624C10.5278 18.3742 11.4888 17.1407 12.4331 15.9552C12.6887 15.6196 14.3414 13.6649 15.0855 12.1225C15.0855 12.1225 16 10.4282 16 8.06198C16 5.84859 15.0981 4.31348 15.0981 4.31348L12.5016 5.01075L10.9247 9.17525L10.5346 9.7495L10.4566 9.85353L10.3528 9.98376L10.1707 10.1918L9.91043 10.4527L8.50625 11.5998L4.99562 13.6323L4.41162 17.0376Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.788086 11.8381C1.6449 13.8005 3.29715 15.5256 4.41502 17.0394L10.3526 9.98688C10.3526 9.98688 9.51609 11.0839 7.99871 11.0839C6.30852 11.0839 4.94309 9.73049 4.94309 8.02398C4.94309 6.85374 5.64521 6.0498 5.64521 6.0498L1.61465 7.13275L0.788086 11.8381Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4189 0.362305C12.3909 0.99985 14.0788 2.3383 15.0997 4.31197L10.3544 9.98226C10.3544 9.98226 11.0565 9.16378 11.0565 8.00081C11.0565 6.25457 9.59009 4.95002 8.0059 4.95002C6.50784 4.95002 5.64746 6.04518 5.64746 6.04518V2.47298L10.4189 0.362305Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87598 2.86811C3.05379 1.45508 5.12629 0 7.98354 0C9.36979 0 10.4142 0.364929 10.4142 0.364929L5.64316 6.04869H2.26285L1.87598 2.86811Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.78825 11.838C0.78825 11.838 0 10.2901 0 8.0478C0 5.92848 0.821625 4.07595 1.87594 2.86816L5.64581 6.04925L0.78825 11.838Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_2377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocate);
export default __webpack_public_path__ + "static/media/locate.946572aea4dd297894afa10277569164.svg";
export { ForwardRef as ReactComponent };